export const lightTheme = {
    '--topbar-background': '#ffd000',
    '--sidebar-background': '#ffffff',
    '--main-panel-background': '#f5f5f5',
    '--panel-background': '#ffffff',
    '--panel-actions-background': '#1A1446',
    '--nav-icon-selected-background': '#ffd000',
    '--nav-icon-background': '#efefef',
    '--text-color': '#1a1446',
    '--msg-text-color': '#fff',
    '--secondary-text-color': '#555',
    '--tertiary-text-color': '#777',
    '--selected-color': '#5766e1',
    '--sub-nav-background': '#ffffff',
    '--control-background': '#f1f3f6',
    '--control-border': '#d1d8e3',
    '--control-placeholder': '#c1c7d0',
    '--primary-button-background': '#ffd000',
    '--primary-button-background-hover': '#E6B800',
    '--primary-button-background-active': '#CC9E00',
    '--ai-button-background': '#1a1446',
    '--ai-button-background-hover': '#2E2570',
    '--ai-button-background-active': '#0F0A3A',
    '--secondary-button-background': '#99e5ea',
    '--secondary-button-background-hover': '#80D0D5',
    '--secondary-button-background-active': '#66BBC0',
    '--chat-background': '#fff',
    '--table-main-columns': '#ffffff',
    '--table-row-hover': '#fff',
    '--panel-shadow': '#e8e8e8',
    '--line-seperator': '#dadada',
    '--chat-assistant-msg-bg': '#FFF5CC',
    '--chat-user-msg-bg': '#ffffff',
    '--link-color': '#06748c',
    '--border-color': '#efefef'
};

export const darkTheme = {
    '--topbar-background': '#16182c',
    '--sidebar-background': '#16182c',
    '--main-panel-background': '#212642',
    '--panel-background': '#1b1d33',
    '--panel-actions-background': '#17182c',
    '--nav-icon-selected-background': '#9764f5',
    '--nav-icon-background': '#212642',
    '--text-color': '#fff',
    '--msg-text-color': '#fff',
    '--secondary-text-color': '#ffffff',
    '--tertiary-text-color': '#fff',
    '--selected-color': '#9764f5',
    '--sub-nav-background': '#181a2f',
    '--control-background': '#111224',
    '--control-border': '#15152a',
    '--control-placeholder': '#837a95',
    '--primary-button-background': '#00b7ec',
    '--primary-button-background-hover': '#00c6ff',
    '--primary-button-background-active': '#00a6d9',
    '--ai-button-background': '#9a6afc',
    '--ai-button-background-hover': '#a579ff',
    '--ai-button-background-active': '#8e60ee',
    '--secondary-button-background': '#2b2d50',
    '--secondary-button-background-hover': '#373963',
    '--secondary-button-background-active': '#222442',
    '--chat-background': '#141528',
    '--table-main-columns': '#1f2038',
    '--table-row-hover': '#16162a',
    '--panel-shadow': '#1f1d2b',
    '--line-seperator': '#222642',
    '--chat-assistant-msg-bg': '#7d4bc6',
    '--chat-user-msg-bg': '#17182c',
    '--link-color': '#3db7ec',
    '--border-color': '#47455a'
};

export const courmacsTheme = {
    '--topbar-background': '#ffffff',
    '--sidebar-background': '#22313a',
    '--main-panel-background': '#f4f7f9',
    '--panel-background': '#ffffff',
    '--panel-actions-background': '#e9f2f7',
    '--nav-icon-selected-background': '#1f9ae0',
    '--nav-icon-background': '#2c3d47',
    '--text-color': '#1f2a33',
    '--msg-text-color': '#fff',
    '--secondary-text-color': '#667784',
    '--tertiary-text-color': '#8796a2',
    '--selected-color': '#1f9ae0',
    '--sub-nav-background': '#1f2c35',
    '--control-background': '#f8fafb',
    '--control-border': '#d9e2e8',
    '--control-placeholder': '#95a4af',
    '--primary-button-background': '#1f9ae0',
    '--primary-button-background-hover': '#1688c8',
    '--primary-button-background-active': '#1172a8',
    '--ai-button-background': '#1a1446',
    '--ai-button-background-hover': '#2E2570',
    '--ai-button-background-active': '#0F0A3A',
    '--secondary-button-background': '#99e5ea',
    '--secondary-button-background-hover': '#80D0D5',
    '--secondary-button-background-active': '#66BBC0',
    '--chat-background': '#fff',
    '--table-main-columns': '#ffffff',
    '--table-row-hover': '#f8fbfd',
    '--panel-shadow': 'rgba(19, 42, 57, 0.08)',
    '--line-seperator': '#e4eaee',
    '--chat-assistant-msg-bg': '#FFF5CC',
    '--chat-user-msg-bg': '#ffffff',
    '--link-color': '#167fc0',
    '--border-color': '#dde6eb'
};
